import React from "react";
import { SliceComponentProps, PrismicRichText } from "@prismicio/react";
import { getImage, withArtDirection } from "gatsby-plugin-image";

import { Text } from "@ui/Atoms/Text";
import { mediaQueries } from "@ui/themes/default";

import { PrismicLandingPageV2DataBodyHero } from "@www/graphql-types";

import * as Styled from "./Hero.styled";

export const Hero = (
  props: SliceComponentProps<PrismicLandingPageV2DataBodyHero>,
) => {
  const primary = props.slice.primary;
  const isHeroBody = !!primary.hero_body.richText?.length;

  const heroResponsiveImage =
    primary.hero_picture?.gatsbyImageData &&
    withArtDirection(getImage(primary.hero_picture.gatsbyImageData)!, [
      {
        media: mediaQueries.desktop,
        image: getImage(
          primary.hero_picture?.thumbnails.desktop?.gatsbyImageData,
        )!,
      },
      {
        media: mediaQueries.tablet,
        image: getImage(
          primary.hero_picture?.thumbnails.tablet?.gatsbyImageData,
        )!,
      },
      {
        media: mediaQueries.desktopLarge,
        image: getImage(
          primary.hero_picture?.thumbnails.desktopLarge?.gatsbyImageData,
        )!,
      },
    ]);

  return (
    <Styled.Root>
      <Styled.Image
        image={heroResponsiveImage}
        alt={primary.hero_picture?.alt || ""}
      />
      <Styled.TextWrapper>
        <Text
          as="h1"
          $style={{
            default: "bold_32",
            desktop: "bold_72",
          }}
          $color="grey800"
        >
          {primary.hero_title.text}
        </Text>

        {!isHeroBody && (
          <Text
            as="p"
            $style={{
              default: "regular_16",
              desktop: "regular_18",
            }}
          >
            {primary.hero_subtitle.text}
          </Text>
        )}

        {isHeroBody && (
          <PrismicRichText
            field={primary.hero_body.richText}
            components={{
              paragraph: props => (
                <Text
                  key={props.key}
                  as="p"
                  $style={{
                    default: "regular_16",
                    desktop: "regular_18",
                  }}
                >
                  {props.children}
                </Text>
              ),
              strong: props => (
                <Text
                  key={props.key}
                  as="strong"
                  $style={{
                    default: "bold_16",
                    desktop: "bold_18",
                  }}
                >
                  {props.children}
                </Text>
              ),
            }}
          />
        )}
      </Styled.TextWrapper>
    </Styled.Root>
  );
};
